<script setup>
// GBS-authored HTML, sanitised (utils/safeHtml.js): simple formatting and links only
import { computed } from 'vue'
import { sanitizeHtml } from '@/utils/safeHtml.js'

const props = defineProps({
  html: { type: String, default: '' }
})

const clean = computed(() => sanitizeHtml(props.html))
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="safe-html" v-html="clean"></div>
</template>

<style scoped>
.safe-html :deep(p:last-child),
.safe-html :deep(ul:last-child),
.safe-html :deep(ol:last-child) {
  margin-bottom: 0;
}
</style>
